import React from 'react';
import PropTypes from 'prop-types';
import Base from '../Base';
import ColorPicker from 'components/common/ColorPicker';

@autobind
/**
 *
 */
export default class Color extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  static defaultProps = {
    value: '#1273de',
  };

  /**
   *
   * @return {XML}
   */
  get _component() {
    const { value, onChange } = this.props;

    return (
      <ColorPicker
        color={value}
        onChange={(color) => onChange(color.hex || color)}
      />
    );
  }
}
